import React from 'react';
import { Modal, notification } from 'antd';
import styles from './SubmitApprovalModal.module.scss';
import {
  ButtonLabels,
  FieldLabels,
  SubmitApprovalModalViewProps,
  initialValues,
} from './SubmitApprovalConstants';
import { Formik, Form, FormikProps } from 'formik';
import COCheckbox from '../COCheckbox';
import COButton from '../COButton';
import { modalCloseIcon } from '../OrganizationModal';
import FarmboxCommodityDistributionService from 'services/Farmbox/CommodityDistribution/commodityDistribution.service';
import useFarmboxRedirections from 'shared/utils/useFarmboxRedirections';
import EmissionService from 'services/ProductsService/emission.service';

interface SubmitApprovalModalProps {
  showModalState: boolean;
  handleModalCancel: () => void;
  handleModalConfirm: () => void;
  productId?: string | undefined;
  commodityId?: string;
  heading?:string;
  content?:string;
  confirmationText?:string;
  isLiveStock?:boolean
}

const SubmitApprovalModal: React.FC<SubmitApprovalModalProps> = ({
  showModalState,
  handleModalCancel,
  productId,
  commodityId,
  heading,
  content,
  confirmationText,
  isLiveStock = false
}: SubmitApprovalModalProps) => {
  const { redirectToFarm } = useFarmboxRedirections();
  const { UpdateProductStatus } = EmissionService();
  const { approvalReport } = FarmboxCommodityDistributionService();

  const handleFormSubmission = async () => {
    if (commodityId) {
      await approvalReport(Number(commodityId), isLiveStock);
      redirectToFarm('in-review');
    } else {
      try {
        const message = await UpdateProductStatus(productId, {
          status: SubmitApprovalModalViewProps.IN_REVIEW,
        });
        if (message && message.length > 0) {
          notification.error({
            message: message.map((item: string, index: number) => (
              <p>
                {index + 1}. {item}
              </p>
            )),
            duration: 8,
          });
        }
      } catch (error) {}
    }
    handleModalCancel();
  };

  return (
    <Modal
      destroyOnClose={true}
      width={450}
      footer={null}
      wrapClassName={styles.modalContainer}
      open={showModalState}
      closeIcon={modalCloseIcon}
      onCancel={handleModalCancel}>
      <div className={styles.formContainer}>
        <div className={styles.headerContainer}>
          <div className={styles.headingContent}>
            <h2>{heading}</h2>
          </div>
        </div>
        <div className={styles.contentContainer}>
          <h3>{content}</h3>
        </div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={handleFormSubmission}>
          {(formik: FormikProps<{ condition: boolean }>) => (
            <Form>
              <div className={styles.fieldContainer}>
                <div className={styles.checkboxContainer}>
                  <COCheckbox name={FieldLabels.CHECKBOX_NAME} />
                </div>
                <div className={styles.conditionContent}>
                  <h3>{confirmationText}</h3>
                </div>
              </div>
              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={formik.isSubmitting}
                  disabled={
                    formik.getFieldProps(FieldLabels.CHECKBOX_NAME).value !==
                    true
                  }>
                  {ButtonLabels.SUBMIT}
                </COButton>
                <COButton secondary onClick={handleModalCancel}>
                  {ButtonLabels.CANCEL}
                </COButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default SubmitApprovalModal;
